import { HTMLSelect } from "@blueprintjs/core";
import useMapViewConfiguration from "contexts/MapViewConfigurationContext/hooks/useMapViewConfiguration";
import React from "react";
import { LocationFilter as LocationFilterValue } from "types/busFilterTypes";
import FilterWrapper from "./FilterWrapper";

type LocationOption = {
    readonly value: LocationFilterValue;
    readonly label: string;
};

const LOCATION_OPTIONS: ReadonlyArray<LocationOption> = [
    { value: LocationFilterValue.ALL, label: "All locations" },
    { value: LocationFilterValue.PIL, label: "Planned (PIL) only" },
    { value: LocationFilterValue.UPIL, label: "Unplanned (UPIL) only" }
];

const LocationFilter: React.FC = () => {
    const {
        busFiltersConfiguration: {
            busFilters,
            updateLocationFilter,
            filtersDisabled
        }
    } = useMapViewConfiguration();

    const currentFilter = busFilters.locationFilter ?? LocationFilterValue.ALL;

    return (
        <FilterWrapper label="Location type">
            <HTMLSelect
                value={currentFilter}
                onChange={(e) =>
                    updateLocationFilter(
                        e.currentTarget.value as LocationFilterValue
                    )
                }
                disabled={filtersDisabled}
                fill={true}
            >
                {LOCATION_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </HTMLSelect>
        </FilterWrapper>
    );
};

export default LocationFilter;
